import React, { FC } from 'react';
import styled from 'styled-components';

import BaseCard, { IBaseCard } from '@ui/atoms/BaseCard';

import theme from '@theme/FolxTheme';

interface ICardCtaWithBackgroundProps extends IBaseCard {
	background: string;
	href: string;
}

const BackgroundImageCard = styled(BaseCard)<{ background: string }>`
	aspect-ratio: 2 / 1;

	background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.4) 30%, rgba(0, 0, 0, 0) 60%),
		url(${({ background }) => background});
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;

	border-radius: ${theme.radius.xl};
	cursor: pointer;

	max-height: 30rem;
	max-width: 60rem;
	min-height: ${theme.spacing.xxxxxl};
	width: 100%;
`;

const CardCtaWithBackground: FC<ICardCtaWithBackgroundProps> = ({ background, href, ...props }) => {
	return (
		<BackgroundImageCard
			{...props}
			borderless
			background={background}
			padding="md"
			onClick={() => window.open(href, '__blank')}
		/>
	);
};

export default styled(CardCtaWithBackground)``;
